import { render, staticRenderFns } from "./redemptionOrder.vue?vue&type=template&id=e896bc3a&scoped=true&"
import script from "./redemptionOrder.vue?vue&type=script&lang=js&"
export * from "./redemptionOrder.vue?vue&type=script&lang=js&"
import style0 from "./redemptionOrder.vue?vue&type=style&index=0&id=e896bc3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e896bc3a",
  null
  
)

export default component.exports